
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { TimeTracker } from "./time-tracking/TimeTracker";
import { ManualEntryDialog } from "./time-tracking/ManualEntryDialog";

export function ProjectTimeTracker() {
  const [showManualDialog, setShowManualDialog] = useState(false);

  return (
    <>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <TimeTracker />
        <div className="w-full sm:w-auto">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowManualDialog(true)}
            className="w-full sm:w-auto"
          >
            <Plus className="mr-2 h-4 w-4" />
            Manueller Eintrag
          </Button>
        </div>
      </div>

      <ManualEntryDialog 
        open={showManualDialog}
        onOpenChange={setShowManualDialog}
      />
    </>
  );
}
